import { render, staticRenderFns } from "./houseOtherInfo.components.vue?vue&type=template&id=6c67f15a&scoped=true"
import script from "./houseOtherInfo.components.vue?vue&type=script&lang=js"
export * from "./houseOtherInfo.components.vue?vue&type=script&lang=js"
import style0 from "./houseOtherInfo.components.vue?vue&type=style&index=0&id=6c67f15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67f15a",
  null
  
)

export default component.exports